<template>
  <div :class="` header-chart-wrapper ${type}`">
    <div class="header-chart">
      <chart :options="options" autoresize ref="chart"></chart>
    </div>
  </div>
</template>
<script>
import ECharts from "vue-echarts";

import "echarts/lib/chart/line";
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/pie';
// import 'echarts/lib/chart/scatter';
// import 'echarts/lib/chart/radar';
// import 'echarts/lib/chart/map';
// import 'echarts/lib/chart/treemap';
// import 'echarts/lib/chart/graph';
// import 'echarts/lib/chart/gauge';
// import 'echarts/lib/chart/funnel';
// import 'echarts/lib/chart/parallel';
// import 'echarts/lib/chart/sankey';
// import 'echarts/lib/chart/boxplot';
// import 'echarts/lib/chart/candlestick';
// import 'echarts/lib/chart/effectScatter';
// import 'echarts/lib/chart/lines';
// import 'echarts/lib/chart/heatmap';
// import 'echarts/lib/component/graphic';
// import 'echarts/lib/component/grid';
// import 'echarts/lib/component/legend';
// import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/polar';
// import 'echarts/lib/component/geo';
// import 'echarts/lib/component/parallel';
// import 'echarts/lib/component/singleAxis';
// import 'echarts/lib/component/brush';
// import 'echarts/lib/component/title';
// import 'echarts/lib/component/dataZoom';
// import 'echarts/lib/component/visualMap';
// import 'echarts/lib/component/markPoint';
// import 'echarts/lib/component/markLine';
// import 'echarts/lib/component/markArea';
// import 'echarts/lib/component/timeline';
// import 'echarts/lib/component/toolbox';

export default {
  components: {
    chart: ECharts,
  },
  name: "n-header-chart",

  props: {
    type: {
      type: String,
      description: "Chart type (health | activity | safety )",
      default: "actid-default",
    },
    chartOptions: {
      type: Object,
      description:
        "Chart data " +
        '(data (Main line data (или "Обработанные"), type: Array), ' +
        'xAxis (x axis text(if undefined it will be Array of " "), type: Array)',
    },
  },

  methods: {},

  mounted() {
    // this.updateHeaderChart()

    if (this.chartOptions.xAxis === undefined) {
      // console.log('123')
      for (let i = 0; i < this.chartOptions.data.length; i++) {
        // this.options.xAxis.data.push(i)
      }
    } else this.options.xAxis.data = this.chartOptions.xAxis;
  },

  data() {
    return {
      options: {
        // legend: {
        //   show: true,
        //   selectedMode: false,
        // },
        grid: {
          left: "15px",
          right: "15px",
          top: "10px",
          bottom: "0px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: false,
          // min: 'dataMin',
          // max: 'dataMax',
          scale: true,
          show: false,
          axisLine: {
            // onZero: false,
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 14,
            // padding: [20, 0, 0, 0],
            fontFamily: "Open Sans",
            color: "rgba(256, 256, 256, .8)",
            fontWeight: "900",
          },
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "none",
          },
        },
        yAxis: {
          type: "value",
          boundaryGap: false,
          // min: 'dataMin',
          // max: 'dataMax',
          scale: true,
          axisLine: {
            // onZero: false,
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            fontSize: 14,
            padding: [0, 20, 0, 0],
            fontFamily: "Open Sans",
            color: "rgba(256, 256, 256, .8)",
            fontWeight: "900",
          },
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "none",
          },
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        series: [
          {
            id: "dataMain",
            name: "",
            type: "line",
            connectNulls: true,
            smooth: true,
            data: [],
            itemStyle: {
              color: "#fff",
              // borderColor: '#1099dd',
              borderWidth: 3.5,
              opacity: 1,
            },
            lineStyle: {
              // color: "#1099dd",
              opacity: 0.8,
              width: 4,
            },
            areaStyle: {
              opacity: 0.8,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(0, 0, 0, 0)", // color at 0% position
                  },
                  {
                    offset: 0,
                    color: "rgba(0, 0, 0, 0)", // color at 100% position
                  },
                ],
                global: false, // false by default
              },
            },
          },
        ],
      },
    };
  },
};
</script>
<style scoped lang="scss">
//Общее
.header-chart-wrapper {
  margin: -93px -30px -130px -30px;
  padding: 68px 0px 150px 0px;

  /*background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);*/
  /*background-image: linear-gradient(120deg, #d4fc79 0%, #62b587 100%);*/
  //background-image: linear-gradient(-60deg, #16a085 0%, #f4d03f 100%);
}
.actid-default {
  // background-image: linear-gradient(0deg, #5853a2 30%, #1f6d79 100%);
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header-chart {
  /*border: solid black 1px;*/
  height: 250px;
}
.echarts {
  width: 100%;
  height: 100%;
}

@media (prefers-color-scheme: dark) {
  .actid-default {
    background-image: linear-gradient(135deg, #3b4a8b 0%, #442b5e 100%);
  }
}
</style>
